import {apiUrl} from './../constantsSMB/apiUrl'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../serviceSMB/logService';
import {redirectTo} from './redirection'
import { Utils } from '../utilSMB/utils';
import {Pages} from '../constantsSMB/actionType'

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        
export const errorAction = (error, page, errorMessage, logName, cookieVal, dispatch, isQueryStringLBO, QueryString) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', cookieVal, 'getbannerFromAPI', "Inside getbannerFromAPI"));
        if (cookieVal === '')
            cookieVal = "VisitIdEmpty"
        logKafka(error, page, errorMessage, getErrorLogUrl, logName, cookieVal);
        if (isQueryStringLBO && error !== 'MON-400') {
            if (window.location.search.toLowerCase().indexOf('productnotreturned') < 0) {
                let lboUrl = Pages.LBO + "?Message=" + QueryString;
                dispatch({
                    type: 'LBO',
                    value: errorMessage,
                    frompage: page,
                    error: error
                });
                redirectTo(lboUrl, dispatch)
            }
        }
        else if (error === "LBO" && window.location.search.toLowerCase().indexOf('productnotreturned') < 0) {
            redirectTo(Pages.LBO, dispatch)
        }
        else if (error === 'MON-400') {
            Utils.clearMemory();
            redirectTo(Pages.CheckLQ + "?Message=" + QueryString, dispatch);
        }
        if (error) {
            dispatch({
                type: 'LBO',
                value: errorMessage,
                frompage: page,
                error: error
            });
        }
    }
    catch (ex) {
        let errorMsg = `MethodName:getbannerFromAPI,errorMessage:${error.message}`;
        logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", cookieVal);
        catchJSException('error', cookieVal, 'action_errorAction', ex);

    }
};

export const clientException = (dispatch,errorDetails) => {
    //Log Page Level Kafka Issue  here
    //logKafka(error,page,errorMessage,getErrorLogUrl,logName,cookieVal);       
    dispatch({
        type: 'CLIENT_EXCEPTION',
        value: errorDetails
    });
};

export const logout = (dispatch) => {
    dispatch({ type: "CLEAR_STORE" });
    redirectTo(Pages.CheckLQ, dispatch);
}
export const logoutSmartSave = (dispatch,mon) => {
    dispatch({ type: "CLEAR_STORE" });
    redirectTo(Pages.ResumeCart+"?xpsid="+mon+"&ordertype=SmartSave&XpsSource=SaveOverlay", dispatch);
}

export const logOutVendorFlow = (dispatch)=>{
    dispatch({ type: "CLEAR_STORE" });
}
